'use client';

import { useMobileApp } from '@/providers/mobile-app-context';
import dynamic from 'next/dynamic';

const NativePullToRefresh = dynamic(() => import('./native_pull_to_refresh'), { ssr: false });
const NativePageTransition = dynamic(() => import('./native_page_transition'), { ssr: false });

// native-app-only wrapper: adds pull-to-refresh + page transition around route content, web is untouched
export default function NativeContentWrapper({ children, routeKey }) {
    const { isNativeApp } = useMobileApp();

    if (!isNativeApp) return children;

    return (
        <NativePullToRefresh>
            <NativePageTransition routeKey={routeKey}>
                {children}
            </NativePageTransition>
        </NativePullToRefresh>
    );
}
